export default "__VITE_ASSET__BrAFSo3E__"